import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TempService {

  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }


  editDoctorInTemp(data:any){
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerProfile/edit-doctor', data, httpOptions);

  }
  editHospitalProfile(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerProfile/edit-provider-Branch-profile', data, httpOptions);
  }


  editProviderServiceV1(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerProfile/edit-provider-facilities-other-facilities', data, httpOptions);
  }
  getNewAilement(){
    let params = new HttpParams()
     .set('commonName', '')
     const options = {
       headers: new HttpHeaders()
         .set('Content-Type', 'application/json'),
       params: params
     };
     return this.http.get(environment.apiBaseUrl + '/trueclaim/ailments/getPresentAilment', options);
   }
   editContactList(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/providerProfile/edit-provider-branch-profile-contacts', data, httpOptions);
  }

  getNotifications(){
    // let params = new HttpParams()
    // .set('commonName', '')
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      // params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/getProviderNotifications', options);

  }

  getNotificationCount(){
     // let params = new HttpParams()
    // .set('commonName', '')
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      // params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/getNotificationsCountOfProvider', options);

  }

  getNotificationDetails(){
     // let params = new HttpParams()
    // .set('commonName', '')
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      // params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/getAllProviderNotifications', options);

  }


  clearNotifications(claimId:any){

     let params = new HttpParams()
    .set('claimId', claimId)
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/updateSeenProviderNotifications', options);
  }


  PresentAilmentCommon(data:any){
    let params = new HttpParams()
    .set('ailementName', data)
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/ailments/getPresentAilmentCommonName', options);
  

  }

  getCityAndStateByPincode(pincode:any){
    
    const params = new HttpParams().set('pincode', pincode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(environment.apiClaimsUrl + '/trueclaim/getCityAndStateByPincode', options);
  }
}
